export default "__VITE_ASSET__CS7OCI8H__"